module.exports = __webpack_public_path__ + "static/media/landing-feature-renovation.583d1b7a.svg";